import romanApi from "@roman/shared/lib/net/romanApi";
import useSWR, { type SWRConfiguration } from "swr";

export type LeaderboardSlice = {
  rankStart: number;
  rankEnd: number;
  percent: number;
};

export type LeaderboardCycle = {
  id: string;
  name: string;
  rewardType: string;
  totalAmount: number;
  concludedAt?: string | null;
  slices: LeaderboardSlice[];
};

type ActiveLeaderboardCycleResponse = {
  leaderboardCycle: LeaderboardCycle;
};

export type UseGetActiveLeaderboardCycleProps = {
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string) => Promise<ActiveLeaderboardCycleResponse>;
};

export const createDefaultActiveLeaderboardCycleFetcher = () => {
  return (url: string) => {
    return romanApi.get<ActiveLeaderboardCycleResponse>(url, undefined);
  };
};

export const useGetActiveLeaderboardCycle = ({ swrOptions, fetcher }: UseGetActiveLeaderboardCycleProps) => {
  const leaderboardFetcher = fetcher || createDefaultActiveLeaderboardCycleFetcher();

  const swrQuery = useSWR("/leaderboard/active", (url: string) => leaderboardFetcher(url), swrOptions);

  return {
    leaderboardCycle: swrQuery.data?.leaderboardCycle ?? null,
    ...swrQuery,
  };
};
